import React from "react";
import BaseTooltip from "../../../components/ui/BaseTooltip";
import { PaymentType, PaymentTypeTooltip } from "../../../utils/enum";

// Radio label for a payment type. Hovering the label explains how that type is billed.
const PaymentTypeRadioLabel = ({ type }) => {
  return (
    <BaseTooltip content={<p className="text-white max-w-[260px]">{PaymentTypeTooltip[type]}</p>}>
      <span>{PaymentType[type]}</span>
    </BaseTooltip>
  );
};

export default PaymentTypeRadioLabel;
